import api from "./api";

const route = "/payment_methods";

const PaymentMethodService = {
  getPaymentMethods: () => api.get(route),
};

export default PaymentMethodService;